<template>
   <div>
    <div v-for="(em, ei) in messageList" :key="ei">
      <div v-if="messageList.length > 0" class="msg-oms-list" @click="openPage(em)">
        <div class="msg-oms-list-content">
          <div class="red" v-if="em.status == 1"></div>
          {{ em.content }}
        </div>
        <div class="msg-oms-list-time">
          {{ em.createTimeStr }}
        </div>
      </div>
    </div>
    <div v-if="messageList.length == 0">
      <a-empty description="暂无数据"/>
    </div>

  </div>
</template>

<script>
import { post } from '@/utils/http';
import api from '@/api';
// import ToDoMsg from './tabs/ToDoMsg.vue';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      messageList: [],
    };
  },
  mounted() {
    this.init();
  },
  watch: {
    visible(val) {
      if (val) {
        this.init();
      }
    },
  },
  methods: {
    init() {
      this.getListTopFive();
    },
    // 获取列表
    getListTopFive() {
      post(api.listTopFive, {}).then((res) => {
        this.messageList = res;
      });
    },
    openPage(em) {
      this.$emit('openPage', em);
    },
  },
};
</script>
<style lang="less" scoped>

.msg-box {
  width: 308px;
  background-color: #fff;
  box-shadow: 0px 2px 10px 0px rgba(0, 0, 0, 0.05);

  .msg-oms-list {
    width: 100%;
    border-bottom: 1px solid #E1E1E1;
    padding: 16px;
    position: relative;
    cursor: pointer;

    .red {
      display: inline-block;
      width: 6px;
      height: 6px;
      left: 10px;
      background-color: red;
      border-radius: 50%;
      margin-right: 8px;
    }

    &-content {
      width: 100%;
      max-height: 40px;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 14px;
      font-weight: normal;
      line-height: 20px;
      letter-spacing: 0px;
      color: #222222;
      text-align: left;
    }

    &-time {
      text-align: left;
      width: 100%;
      height: 17px;
      color: #999999;
      font-size: 12px;
      margin-top: 12px;
    }
  }

  .msg-btn {
    width: 100%;
    height: 46px;
    display: flex;
    cursor: pointer;

    div {
      flex: 1;
      text-align: center;
      line-height: 46px;
      font-size: 12px;
      color: #666666;
    }
  }

}
</style>
